import React from "react";
import DropDownIcon from "./dropdownicon.png";
import { Link } from "react-router-dom";

import {
  IconContainer,
  ContentMainContainer,
  ContentInnerContainer,
  ColumnContainer,
  TitleContent,
} from "./styled.components";

const popover = ({ title, url }) => {
  return (
    <ContentMainContainer>
      <Link to={url}>
        <ContentInnerContainer>
          <ColumnContainer>
            <TitleContent>{title}</TitleContent>
          </ColumnContainer>
        </ContentInnerContainer>
      </Link>
    </ContentMainContainer>
  );
};

export default popover;
